import { validate as validateCNPJ } from 'cnpj'
import * as Yup from 'yup'

class YupCnpjValidator {
  public verify() {
    return Yup.string().test('CNPJ', 'Valor inválido', function (val) {
      const { path, createError } = this
      const message = createError({
        path,
        message: `${path} não contém um valor válido`
      })

      if (!val) return message

      const isCNPJValid = validateCNPJ(val)
      if (isCNPJValid) return true
      return message
    })
  }
}

export const YupCNPJ = new YupCnpjValidator()
